// Minimal markdown → HTML for the Review page preview tab.
// Handles the patterns the v2 synthesis prompt actually emits:
//   ## Heading 2     -> <h2>
//   ### Heading 3    -> <h3>
//   **bold**         -> <strong>
//   *italic*         -> <em>
//   - list item      -> <ul><li>
//   blank-line para  -> <p>

export function escapeHtml(s: string): string {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function inlineFormat(s: string): string {
  return s
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|\W)\*([^*]+)\*(?=\W|$)/g, '$1<em>$2</em>');
}

export function markdownToHtml(md: string): string {
  if (!md) return '';
  const lines = md.replace(/\r\n/g, '\n').split('\n');
  const out: string[] = [];
  let buf: string[] = [];
  let inList = false;

  function flushBuf() {
    if (buf.length === 0) return;
    out.push(`<p>${inlineFormat(buf.join(' ').trim())}</p>`);
    buf = [];
  }
  function flushList() {
    if (inList) { out.push('</ul>'); inList = false; }
  }

  for (const raw of lines) {
    const line = raw.replace(/\s+$/, '');
    if (/^##\s+/.test(line)) {
      flushBuf(); flushList();
      out.push(`<h2>${escapeHtml(line.replace(/^##\s+/, ''))}</h2>`);
    } else if (/^###\s+/.test(line)) {
      flushBuf(); flushList();
      out.push(`<h3>${escapeHtml(line.replace(/^###\s+/, ''))}</h3>`);
    } else if (/^[-*]\s+/.test(line)) {
      flushBuf();
      if (!inList) { out.push('<ul>'); inList = true; }
      out.push(`<li>${inlineFormat(escapeHtml(line.replace(/^[-*]\s+/, '')))}</li>`);
    } else if (line === '') {
      flushBuf(); flushList();
    } else {
      flushList();
      buf.push(escapeHtml(line));
    }
  }
  flushBuf(); flushList();
  return out.join('\n');
}
